import React from 'react';
import CloseButton from './shared/CloseButton';

interface OptimalTimePopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const OptimalTimePopup: React.FC<OptimalTimePopupProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 100001,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--surface)',
          color: '#f3f4f6',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
          maxWidth: '600px',
          maxHeight: '80vh',
          overflow: 'auto',
          margin: '1rem',
          border: '1px solid var(--surface-selected)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
          marginBottom: '1.5rem'
        }}>
          <h3 style={{ 
            color: '#f3f4f6 !important', 
            margin: 0, 
            fontSize: '1.25rem', 
            fontWeight: 'bold' 
          }}>
            How is Optimal Time Calculated?
          </h3>
          <CloseButton onClick={onClose} ariaLabel="Close popup" />
        </div>
        
        <div style={{ 
          color: '#f3f4f6 !important', 
          lineHeight: '1.6',
          fontSize: '1rem'
        }}>
          <p style={{ marginBottom: '1rem', color: '#f3f4f6 !important' }}>
            First, an estimated model of your car's limits at the conditions of the session is calculated. Then, the fastest possible time on the given lap's driving line is determined by simulating the car being driven on the estimated limit.
          </p>
          
          <p style={{ marginBottom: '1rem', color: '#f3f4f6 !important' }}>
            The optimal times varies between laps due to differences in the driving line. The optimal lap time is not accurate under the following conditions:
          </p>
          
          <ul style={{ 
            marginBottom: '1rem', 
            paddingLeft: '1.5rem',
            color: 'var(--text-secondary)'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>
              Variable track or vehicle conditions during the session (e.g. wet track, overheating tires, etc.)
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
                Banked corners - Solution is coming soon
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
                Vehicles with high downforce
            </li>            
            <li style={{ marginBottom: '0.5rem' }}>
                Vehicles with severe understeer or oversteer
            </li>
          </ul>
          
          <p style={{ 
            marginBottom: 0,
            fontStyle: 'italic',
            color: 'var(--text-secondary)'
          }}>
            <strong>The optimal lap time is an estimate and should be used as a guide. It is not a guarantee of the fastest possible time on the given lap, and drivers should increase their speed incrementally until they reach their maximum potential.</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OptimalTimePopup;
